import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { Header } from "../Components/Header";
import { RightBar } from "../Components/RightBar";
import { Breadcrumb } from "../Components/Breadcrumb";
import { SideBar } from "../Components/SideBar";
import RouteFunction, { getRedirectRoute } from "./RouteFunction";
// import * as Page from '../Container'
import { routes } from "../Container";
import "../Components/Layout.css";

export default function Layout() {
  return (
    <>
      <Header />
      <SideBar />
      {/* </Suspense> */}
      <div className="main-content position-relative">
        {/* <Loader /> */}
        <div className="page-content">
          <Breadcrumb />
          <Switch>
            {RouteFunction(routes)}
            <Redirect exact={true} to={getRedirectRoute(routes)} from="*" />
          </Switch>
        </div>
        {/* <Footer /> */}
      </div>
      <RightBar />
    </>
  );
}
